export const c_alert__title_max_lines = {
  "name": "--pf-v6-c-alert__title--max-lines",
  "value": "1",
  "var": "var(--pf-v6-c-alert__title--max-lines)"
};
export default c_alert__title_max_lines;